module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [(_vm.error) ? _c('div', {
    staticClass: "message__error"
  }, [(_vm.addChildError) ? [(_vm.addChildError) ? _c('h3', {
    staticClass: "message__error_text"
  }, [_vm._v("Необходимо перейти в "), _c('router-link', {
    staticClass: "message__link",
    attrs: {
      "to": {
        name: 'profile-cabinet'
      }
    }
  }, [_vm._v("личный кабинет")]), _vm._v(" и добавить обучающегося.")], 1) : _c('h3', {
    staticClass: "message__error_text"
  }, [_vm._v(_vm._s(_vm.noOrderChildMessage))])] : _vm._e(), (_vm.srvErrorMsg) ? [_c('h3', {
    staticClass: "message__error_text"
  }, [_vm._v(_vm._s(_vm.srvErrorMsg))])] : _vm._e()], 2) : _c('div', {
    staticClass: "message__succsess"
  }, [_c('div', {
    staticClass: "message__close",
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }), _c('div', {
    staticClass: "message__image"
  }), _c('h3', {
    staticClass: "message__succsess_text"
  }, [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd47d31","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMessage.vue
// module id = 748834e56b6e9e04b797
// module chunks = 0